// extracted by mini-css-extract-plugin
export default {"academyBanner":"AcademyBanner_academyBanner__D4avF"};